import React, { useEffect, useState } from "react";
import FormProgress from "../AuditAdmin/FormProgress";
import FormComponent from "./FormComponent";
import SendBackAddendum from "../SendBack/SendBackAddendum";
import SendBackFullScope from "../SendBack/SendBackFullScope";
import SendBackGapAseesment from "../SendBack/SendBackGapAseesment";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import {
  auditLoading,
  auditSwitchType,
  protocolType,
  scoringSubmit,
  verisoningVersion,
} from "../../../store/audit details/atom";
import { formProgress } from "../../../store/atoms";
import SendBackScoringDetails from "../SendBack/SendBackScoringDetails";
import { Box, CircularProgress, Modal } from "@mui/material";
import { getToken } from "../../auth/authConfig";
import iconLoading from "../../../assets/img/Loader5.gif";
import AuditFormComponent from "../Versioning/VersioningAuditFormComponent";
import AuditAddendum from "../Versioning/VersioningAuditAddendum";
import submitGif from "../../../assets/img/submit.gif";
import VersioningAuditAddendum from "../Versioning/VersioningAuditAddendum";
import VersioningFullScope from "../Versioning/VersioningFullScope";
import VersioningGapAssesment from "../Versioning/VersioningGapAssesment";
import VersioningScoringDetails from "../Versioning/VersioningScoringDetails";

const SendBackAdmin = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const auditNumber = queryParams.get("auditNumber");
  const [loading, setloading] = useState(false);
  const [authorization, setAuthorization] = useState("");
  const type = useRecoilValue(protocolType);
  const stepsData = useSetRecoilState(protocolType);
  const [unitIndex, setUnitIndex] = useState('');

  const [switchType, setSwitchType] = useRecoilState(auditSwitchType);
  const setProgressValue = useSetRecoilState(formProgress);
  const [versioningValue, setVersioningValue] =
    useRecoilState(verisoningVersion);
  // getting protocol type from atom

  const id = auditNumber ? auditNumber : "N/A";

  const scoringSubmitValue = useRecoilValue(scoringSubmit);

  useEffect(() => {
    if (
      type === "Addendum" ||
      type === "Full Scope" ||
      type === "Gap Assessment"
    ) {
      setProgressValue(2);
    } else if (type === "scoringDetails") {
      setProgressValue(3);
    } else {
      setProgressValue(1);
    }
  }, [type]);

  const getFormStage = async () => {
    setloading(true);
    const url = `${process.env.REACT_APP_SERVER_URL}/api/forms/get_audit_verify/${auditNumber}`;
    const token = await getToken();

    await fetch(`${url}`, {
      headers: {
        "oidc-token": token,
        Accept: "application/json",
      },
    })
      .then((response) => {
        if (response.ok) {
          response.json().then((json) => {
            setloading(false);
            console.log(json);
            setAuthorization(json.Authorization);
            setUnitIndex(json?.unit_index || '');

            if (json.type !== "null") {
              const step =
                json.type === "Scoring Detail" ? "scoringDetails" : json.type;
              if (!switchType) {
                stepsData(step);
              }
            } else {
              stepsData("");
            }

            setVersioningValue(json?.version);
          });
        }
      })
      .catch((err) => {
        setloading(false);
      });
  };

  useEffect(() => {
    getFormStage();
  }, []);
  return (
    <>
      {!loading && authorization === "Authorized" && (
        <>
          <div style={{display:"grid"}}  className="audit-id">
              <span>Mars QMS Audit #: {id}</span>
              <span style={{fontSize:"16px",color:"#8d8d8d",fontWeight:"500"}}>Unit Index is #: {unitIndex || "N/A"}</span>
            </div>
          {type === "" ? (
            <>
              {/* // audit details  */}
              <FormProgress />
              <FormComponent />{" "}
            </>
          ) : type === "Addendum" ? (
            // Addendum page
            <SendBackAddendum version={versioningValue || 1}/>
          ) : type === "Full Scope" ? (
            // full Scope page
            <SendBackFullScope version={versioningValue || 1}/>
          ) : type === "Gap Assessment" ? (
            // Gap assesment page
            <SendBackGapAseesment version={versioningValue || 1}/>
          ) : type === "scoringDetails" ? (
            // scoringDetails
            <>
              {" "}
              {scoringSubmitValue ? (
                <div className="submitGif-box">
                  <img src={submitGif} alt="submitgif" />
                </div>
              ) : (
                <>
                  <FormProgress />
                  <SendBackScoringDetails version={versioningValue || 1} />{" "}
                </>
              )}
            </>
          ) : type === "Completed" ? (
            <div style={{ height: "100%" }}>
              <div className="submitGif-box">
                <img src={submitGif} alt="submitgif" />
              </div>
            </div>
          ) : (
            <></>
          )}
        </>
      )}

      {!loading && authorization === "Unauthorized" && (
        <div
          style={{
            justifyContent: "center",
            alignContent: "center",
            alignItems: "center",
            height: "100%",
            display: "grid",
            fontSize: "30px",
          }}
        >
          <div
            style={{
              textAlign: "center",
              display: "grid",
              alignItems: "center",
              alignContent: "center",
              height: "100%",
            }}
          >
            <h1 class="w3-jumbo w3-animate-top w3-center">
              <code>Access Denied</code>
            </h1>
            <h4 class="w3-center w3-animate-right">
              You have Unauthorized to this form
            </h4>
            <h3 class="w3-center w3-animate-zoom">🚫🚫🚫🚫</h3>
            <h6 class="w3-center w3-animate-zoom">error code:403 forbidden</h6>
          </div>
        </div>
      )}

      {loading && (
        <div
          style={{
            display: "grid",
            alignContent: "center",
            alignItems: "center",
            justifyContent: "center",
            justifyItems: "center",
            gap: "20px",
            height: "100%",
          }}
        >
          <img src={iconLoading} width={100} alt="loading" />
          <span style={{ fontSize: "24px" }}>
            Please wait while loading the form resources
          </span>
        </div>
      )}
    </>
  );
};

export default SendBackAdmin;
